import { Box, Text } from '@factorialco/deprecated-design-system'

import { ImageBox } from './imageBox'

interface InstitutionCardProps {
  institution: {
    id: string
    name: string
    logo: string
  }
}

export const InstitutionHorizontalCard = ({ institution }: InstitutionCardProps) => {
  const { name, logo } = institution

  return (
    <Box
      border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      borderRadius={{ all: 'abs016' }}
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="flexStart"
      padding="s16"
      gap="s16"
    >
      <ImageBox url={logo} name={name} />
      <Box textAlign="center" alignSelf="center" flexDirection="column">
        <Text.Normal size="300" weight="medium">
          {name}
        </Text.Normal>
      </Box>
    </Box>
  )
}
